import { render, staticRenderFns } from "./poll.vue?vue&type=template&id=5780d870&scoped=true"
import script from "./poll.vue?vue&type=script&lang=js"
export * from "./poll.vue?vue&type=script&lang=js"
import style0 from "./poll.vue?vue&type=style&index=0&id=5780d870&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780d870",
  null
  
)

export default component.exports